import { Link } from 'react-router';

export default function PreisePage() {
  return (
    <main className="min-h-screen bg-warm-50 px-6 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl rounded-2xl border border-warm-200/60 bg-white p-8 lg:p-10 shadow-[0_10px_28px_-16px_rgba(26,24,22,0.18)]">
        <h1 className="text-3xl font-semibold tracking-tight text-warm-800 mb-4">Preise</h1>
        <p className="text-warm-600 leading-relaxed mb-6">
          30 Tage kostenlos testen, ohne Kreditkarte. Danach starten flexible Tarife passend zur Praxisgröße und zum Leistungsumfang.
        </p>
        <ul className="space-y-3 text-warm-700">
          <li>Basic: Einstieg für kleine Teams</li>
          <li>Pro: Erweiterte Automatisierungen und KI-Funktionen</li>
          <li>Enterprise: Individuelle Anforderungen, Onboarding und SLA</li>
        </ul>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="mailto:kontakt@getflowly.de?subject=Preisanfrage" className="landing-cta-primary">Angebot anfragen</a>
          <Link to="/" className="landing-cta-secondary">Zur Landing Page</Link>
        </div>
      </div>
    </main>
  );
}
